import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomerService } from '../../../core/customer/customer.service';

@Component({
  selector: 'email-success',
  templateUrl: 'email-success.component.html',
  styleUrls: ['email-success.scss']
})
export class EmailSuccessComponent {

  @Input('user')
  user: string;

  private _nextPageTimeOut = 0;
  sub: any;
  username: string;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private _customerService: CustomerService) {
    this.sub = this.route.params.subscribe(params => {
      this.username = params['username'];
    }, err => (console.error('Sin usuario disponible')));

  }

  goToPreviosPage(): void {
   // setTimeout(() => this.router.navigate(['juegos/carrito']), this._nextPageTimeOut);
  }

  sendEmail(): void {
    this._customerService.sendVerificationEmail()
      .subscribe(
      response => {
        console.log('Se envio el correo satisfactoriamente: ', response);
      },
      err => {
        console.error('charge error, ', err);
        //this.tipoNotificacion = false;
        //this._setError(true, 'Error', err);
      });
  }

}


// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/juegos/components/verification/email-success.component.ts